import { ApiServiceWithSettings } from '../../common'

export class BackofficeProductsApi extends ApiServiceWithSettings {}
